module.exports = __webpack_public_path__ + "img/capsule-blue.3ab9a8d6.svg";